import { render } from "./LeagueSquad.vue?vue&type=template&id=55ff3d57&scoped=true"
import script from "./LeagueSquad.vue?vue&type=script&lang=js"
export * from "./LeagueSquad.vue?vue&type=script&lang=js"

import "./LeagueSquad.vue?vue&type=style&index=0&id=55ff3d57&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ff3d57"]])

export default __exports__